import { Flex, Text, Select } from '@scale/scaleui-radix';
import type { HubstaffMemberRole } from '@scale/genai-compass-shared/cards/hubstaff_member_actions';

interface MemberRoleSelectorProps {
  role: HubstaffMemberRole | undefined;
  onChange: (role: HubstaffMemberRole) => void;
}

export default function MemberRoleSelector({ role, onChange }: MemberRoleSelectorProps) {
  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="bold">
        Step 5: Select member role <span style={{ color: 'red' }}>*</span>
      </Text>
      <Select.Root value={role} onValueChange={value => onChange(value as HubstaffMemberRole)}>
        <Select.Trigger placeholder="Select a role" />
        <Select.Content>
          <Select.Item value="Manager">Manager</Select.Item>
          <Select.Item value="User">User</Select.Item>
          <Select.Item value="Viewer">Viewer</Select.Item>
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
